module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-padding no-margin middle-xs slider"
  }, [_c('div', {
    staticClass: "center-absolute-middle",
    staticStyle: {
      "left": "0px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleBack.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "center-absolute-middle",
    staticStyle: {
      "right": "0px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleForward.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "slides",
    attrs: {
      "id": "slider-track"
    }
  }, _vm._l((_vm.pages), function(slide, index) {
    return _c('div', {
      staticClass: "pane clickable",
      attrs: {
        "id": ("slide-" + (index + 1))
      },
      on: {
        "click": function($event) {
          return slide.handler()
        }
      }
    }, [_c('img', {
      staticStyle: {
        "height": "50px",
        "margin-right": "10px"
      },
      attrs: {
        "src": ("/static/dashboard/" + (slide.image) + ".svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "220px",
        "color": "#797979",
        "font-size": "24px",
        "font-weight": "600",
        "line-height": "29px"
      }
    }, [_vm._v("\n          " + _vm._s(slide.main_text) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#72ccd7",
        "font-size": "16px",
        "line-height": "19px",
        "font-weight": "500"
      }
    }, [_vm._v("\n          " + _vm._s(slide.secondary_text) + "\n        ")])]), _vm._v(" "), _c('i', {
      directives: [{
        name: "my-tooltip",
        rawName: "v-my-tooltip",
        value: (_vm.tooltip),
        expression: "tooltip"
      }],
      staticClass: "fas fa-external-link-alt",
      staticStyle: {
        "font-size": "10px",
        "vertical-align": "top"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dot-container"
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('button', {
      staticClass: "dot",
      class: {
        selected: _vm.selected_page_number === index + 1
      },
      on: {
        "click": function($event) {
          return _vm.handleSlideClick(index)
        }
      }
    })
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6fd77222!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/dashboard/slidingButton.vue
// module id = 1641
// module chunks = 61